import { Empleado } from '../clases/empleado';
import { EmpleadoLookupDTO } from '../dto/empleado-lookup.dto';
import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class EmpleadoService {

  constructor(private readonly http: HttpClient) { }

  
  public getAllEmpleadosPage(param: string,page: number, size: number): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/empleados-page-param?page=" + (page - 1) + "&size=" + size+ (param != "" && param != null ? "&param=" + param : ""));
  }

  

  public getAllEmpleadosByRolePage(id: number,page: number, size: number): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/empleados-page-role?page=" + (page - 1) + "&size=" + size+ "&id=" + id );
  }

  public getAllEmpleados(): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/empleados");
  }

  public getUserDataAuth(): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/getUserdataAuth");
  }

  public getAllEmpleadosByEstado(estado: boolean): Observable<any>{
    //request param estado  
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/empleados-estado?estado=" + estado);
  }

  public editEmpleado(empleado: Empleado): Observable<any>{
    return this.http.put(environment.backEndHost + environment.serverEndPoint + "/empleados/" + empleado.id, empleado);
  }

  public agregarEmpleado(empleado: Empleado): Observable<any>{
    return this.http.post(environment.backEndHost + environment.serverEndPoint + "/empleados/", empleado);
  }  

  public actualizarEstadoEmpleado(id: number, estado: boolean): Observable<any> {
    const url = `${environment.backEndHost}${environment.serverEndPoint}/empleados/${id}`;
    const body = { estado: estado, id: id }; // solo enviamos el atributo estado

    return this.http.patch(url, body);
  }

  /**
   * CP-01: actualización parcial de la marca "afecta capacidad" desde el toggle
   * inline de la tabla. El backend debe soportar este PATCH parcial (ver spec).
   */
  public actualizarAfectaCapacidadEmpleado(id: number, afectaCapacidad: boolean): Observable<any> {
    const url = `${environment.backEndHost}${environment.serverEndPoint}/empleados/${id}`;
    const body = { afectaCapacidad: afectaCapacidad, id: id };

    return this.http.patch(url, body);
  }

  public getAllEmpleadosByEstadoPage(estado: boolean,page: number, size: number): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/empleados/empleados-page-estado?page=" + (page - 1) + "&size=" + size+ (estado == null ? "" : "&estado=" + estado));
  }

  // --- Lookup endpoints (accesibles para todos los roles, incluyendo PM) ---

  public getAllEmpleadosLookup(estado?: boolean, afectaCapacidad?: boolean): Observable<EmpleadoLookupDTO[]> {
    const queryParts: string[] = [];
    if (estado != null) queryParts.push(`estado=${estado}`);
    if (afectaCapacidad != null) queryParts.push(`afectaCapacidad=${afectaCapacidad}`);
    const params = queryParts.length > 0 ? `?${queryParts.join('&')}` : '';
    return this.http.get<EmpleadoLookupDTO[]>(
      `${environment.backEndHost}${environment.serverEndPoint}/empleados-lookup${params}`
    );
  }

  public getAllEmpleadosLookupByRole(roleId: number): Observable<EmpleadoLookupDTO[]> {
    return this.http.get<EmpleadoLookupDTO[]>(
      `${environment.backEndHost}${environment.serverEndPoint}/empleados-lookup-role?id=${roleId}`
    );
  }

}
